import React, { ReactElement } from "react";
import { Link } from "gatsby";
import Nav from "../Nav";
import NavItem from "../NavItem";
import { getPaginationRange } from "../../utils";

interface PaginationProps {
  itemsPerPage: number;
  pagination: {
    count: number;
    start: number;
    end: number;
    page: number;
    path: string;
  };
}

const getPagePath = (basePath: string, page: number): string => {
  if (page === 1) {
    return basePath;
  }

  if (basePath === "/") {
    return `/${page}`;
  }

  return `${basePath.replace(/\/$/, "")}/${page}`;
};

export default ({ pagination }: PaginationProps): ReactElement => {
  const renderRange = (range: { start: number; end: number }) => {
    const items = [
      <Link to={getPagePath(pagination.path, 1)}>
        <NavItem key="pagination-first-page">First Page</NavItem>
      </Link>
    ];

    for (let i = range.start; i <= range.end; i++) {
      items.push(
        <Link to={getPagePath(pagination.path, i)}>
          <NavItem key={i} active={i === pagination.page}>
            {i}
          </NavItem>
        </Link>
      );
    }

    return [
      ...items,
      <Link to={getPagePath(pagination.path, pagination.count)}>
        <NavItem key="pagination-last-page">Last Page</NavItem>
      </Link>
    ];
  };

  return (
    <Nav css={{ border: "none", borderBottom: "1px solid #545454" }}>
      {renderRange(getPaginationRange(pagination.page, pagination.count))}
    </Nav>
  );
};
